
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";

import routes from "routes";

import { FlowProvider } from "flow/flowContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

console.log(process.env)

const App = () => {

  const getRoutes = (routes, path) => {
    return routes.map((prop, key) => {
      if (prop.layout === path) {
        console.log(prop)
        return (
          <Route
            index={prop.indexRoute}
            path={!prop.indexRoute? (prop.layout + prop.path): null} // If its a index route don't set a path
            element={<prop.component/>}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <FlowProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<AdminLayout />} >
                  { getRoutes(routes, "/admin")}
            </Route>
            <Route path="/auth" element={<AuthLayout />} >
                  { getRoutes(routes, "/auth")}
            </Route>  
            <Route path="/" element={ <Navigate from="/" to="/auth" /> }/>
            <Route path="*" element={<h1 className="text-center mt-8"> 404! Url Not Found!</h1> }/>
          </Routes>
        </BrowserRouter>
      </FlowProvider>  
    </>
  )
}

root.render(
  <App/>
);
